import { render, staticRenderFns } from "./GlobalRules.vue?vue&type=template&id=5b1236b1&scoped=true&"
import script from "./GlobalRules.vue?vue&type=script&lang=js&"
export * from "./GlobalRules.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRules.vue?vue&type=style&index=0&id=5b1236b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1236b1",
  null
  
)

export default component.exports